import { usePayoutDetailsQuery, usePatientDiscountIncrementsQuery } from "@shared/data/queries";

import type { OAuthStep } from "../oauthStep";

import {
  OAuthBankingInformation,
  SkeletonOAuthBankingInformation,
} from "./OAuthBankingInformation";

interface Props {
  onOnboardingComplete: () => void;
  onUpdateCurrentStep: (step: OAuthStep) => void;
  onUpdateStoreCurrentSetupPage: (step: string, forProfit?: boolean) => Promise<void>;
}

const OAuthBankingStep = ({ ...props }: Props) => {
  const { loading: incrementsLoading, data: patientDiscountIncrementsData } =
    usePatientDiscountIncrementsQuery();
  const { loading: payoutDetailsLoading, data: payoutDetailsData } = usePayoutDetailsQuery();

  if (incrementsLoading || payoutDetailsLoading) return <SkeletonOAuthBankingInformation />;

  const { patientDiscountIncrements } = patientDiscountIncrementsData?.currentStore ?? {};
  const { marginType, merchantData, stripeAccountState } = payoutDetailsData?.currentStore ?? {};

  return (
    <OAuthBankingInformation
      marginType={marginType}
      profitMarginIncrements={patientDiscountIncrements}
      merchantData={merchantData}
      isFullSsnRequired={stripeAccountState?.isFullSsnRequired ?? false}
      {...props}
    />
  );
};

export { OAuthBankingStep };
